import { Guid } from '@/utils/guid'
import { getFormatMessage } from '@/utils/utils'
import { Select } from 'antd'
import React, { ReactNode } from 'react'

const formatMessage = getFormatMessage()

export const templateState = {
  0: { text: formatMessage({ id: 'app.templateState.0' }), color: 'default' },
  1: {
    text: formatMessage({ id: 'app.templateState.1' }),
    color: 'processing'
  },
  2: { text: formatMessage({ id: 'app.templateState.2' }), color: 'success' },
  3: { text: formatMessage({ id: 'app.templateState.3' }), color: 'error' }
}

export const connectionState = {
  0: { text: formatMessage({ id: 'app.connectionState.0' }), color: 'default' },
  1: { text: formatMessage({ id: 'app.connectionState.1' }), color: 'success' },
  2: { text: formatMessage({ id: 'app.connectionState.2' }), color: 'error' },
  3: { text: formatMessage({ id: 'app.connectionState.3' }), color: 'default' }
}

export function getStatusOptions(status: any): ReactNode[] {
  const options: ReactNode[] = []
  const keys = Object.keys(status)
  for (let key of keys) {
    options.push(
      <Select.Option key={Guid.raw()} value={key}>
        {status[key].text}
      </Select.Option>
    )
  }
  return options
}
